.placeholder {
  height: 100%;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 0.4rem;
  object-fit: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: 400;
  background-color: var(--color-grayscale-tuna);
  color: var(--color-secondary);

  svg {
    height: 1.2rem;
    width: 1.2rem;
  }

  &:hover {
    cursor: pointer;
  }
}
